<template>
  <v-form ref="filterForm" @submit.prevent="submitFilter()" class="filter">
    <v-row dense>
      <v-col cols="12" md="1" class="mx-md-6 mx-lg-0">
        <div
          class="d-flex align-baseline"
          :class="!$vuetify.breakpoint.xsOnly ? 'justify-space-around' : 'mb-6'"
        >
          <div class="mx-md-1 mx-lg-2 mr-2">
            <span>{{ $t("filters") }}</span>
          </div>
          <div class="flex-grow-1 mr-2">
            <v-btn
              outlined
              color="#6A6E7B"
              block
              class="btn--width40"
              :disabled="!cptdTotalFilters"
              @click="clearFilterForm()"
            >
              <v-badge
                color="red"
                overlap
                bottom
                :value="cptdTotalFilters"
                :content="cptdTotalFilters"
              >
                <v-icon> mdi-filter </v-icon>
              </v-badge>
            </v-btn>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="2" lg="1">
        <v-text-field
            v-model="filters.SALES_ORDER"
            :label="$t('orderNumber')"
            outlined
            dense
            clearable
            @click:clear="clearField('SALES_ORDER')"
        />
      </v-col>
      <v-col cols="12" md="2" lg="1">
        <v-text-field
          v-model="filters.CUSTOMER_PO"
          :label="$t('purchaseOrder')"
          outlined
          dense
          clearable
          @click:clear="clearField('CUSTOMER_PO')"
        />
      </v-col>
      <v-col cols="12" md="2" lg="1">
        <input-date
          v-model="filters[initialDateKey]"
          :label="$t('initialDate')"
          :rules="[]"
          @click:clear="clearField(initialDateKey)"
          readonly
          dense
        />
      </v-col>
      <v-col cols="12" md="2" lg="1">
        <input-date
          v-model="filters[finalDateKey]"
          :label="$t('finalDate')"
          :rules="[dateMustBeBiggerRule]"
          readonly
          @click:clear="clearField(finalDateKey)"
          dense
        />
      </v-col>
      <v-col cols="12" md="2" lg="1">
        <v-select
          v-model="filters.TVOA_STATUS_HEADER"
          :items="orderStatus"
          item-text="status.label"
          item-value="status.label"
          dense
          outlined
          @change="clearSelect(filters.TVOA_STATUS_HEADER)"
          :label="$t('status')"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="filters.PRODUCTPROP"
          :label="$t('product')"
          outlined
          dense
          @click:clear="clearField('PRODUCTPROP')"
          clearable
        />
      </v-col>
      <v-col cols="12" md="1">
        <v-btn
          depressed
          color="#D8D8D8"
          :block="$vuetify.breakpoint.xsOnly"
          type="submit"
        >
          <v-icon> mdi-magnify </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="1">
        <v-btn
          depressed
          color="#D8D8D8"
          @click="downloadOrders()"
          :disabled="this.disabled"
        >
          <v-icon
          color="green"
          > 
          mdi-file-excel-box 
        </v-icon>
          Excel
        </v-btn>
      </v-col>
    </v-row>
    <v-divider />
    <TLoading v-model="loading" />
  </v-form>
</template>

<script>
import mixinFilters from "@/mixins/mixinFilter";
import InputDate from "@/arch/components/InputDate";
import { mapState, mapActions } from 'vuex';
import {getCustomerId} from './../../../store/userData';
import XLSX from 'xlsx/xlsx';
import { VUE_APP_COUNTRY } from '@/config'
import {currency, formatDateValue} from "./../../../helpers/filter";
//import AutocompleteLine from "@/components/AutocompleteLine.vue";

export default {
  name: 'OrdersFiltersComponent',
  mixins: [mixinFilters],
  components: {
    InputDate,
    //AutocompleteLine,
  },
  computed:{
    ...mapState({
      orderStatus(_, getters) {
        return getters['ordersStore/getStatus']
      },
    }),
    
  },
  async mounted() {
    await this.setStatusDataToList();
  },
  methods:{
    ...mapActions({
      setStatusDataToList(dispatch, payload) {
        return dispatch('ordersStore/setStatusDataToList', payload)
      },
      setDataToList(dispatch, payload) {
        return dispatch(this.getPathStore + '/setDataToList', {
          ...payload,
          type: 'sales'
        })
      }
    }),
    downloadOrders(){
      this.disabled = true;
      let results = this.submitFilter();
      
      results.then((response) => {

        let headerArray = [[
          this.$i18n.t('orderNumber'),
          this.$i18n.t('purchaseOrder'),
          this.$i18n.t('createdDate'),
          this.$i18n.t('shippingLocation'),
          this.$i18n.t('totalValue'),
          this.$i18n.t('status'),
        ]];
        
        response.data.lista.map(function(data){

          let column
          if(VUE_APP_COUNTRY == 'EC'){
            column = data.SHIPPING_INSTRUCTIONS;
          }else{
            column = data.SHIP_TO;
          }

          headerArray.push([
            data.SALES_ORDER,
            data.CUSTOMER_PO,
            formatDateValue(data.CREATION_DATE),
            column,
            currency(data.TOTAL),
            data.STATUS_HEADER
          ]);  
        });

        let ws_name = 'Orders'
        let wb = XLSX.utils.book_new()
        let ws = XLSX.utils.aoa_to_sheet(headerArray)
        XLSX.utils.book_append_sheet(wb, ws, ws_name)

        this.wb = wb

        this.downloadFile()
        this.disabled = false;
      });
    },
    downloadFile(){
      let filename = 'Orders' + '.xlsx'
      XLSX.writeFile(this.wb, filename)
    },
  },
  data() {
    return {
      path: "orders",
      months: [],
      initialDateKey: "ORDER_DATE_INICIAL",
      finalDateKey: "ORDER_DATE_FINAL",
      items:[
        { value: 'vencida', text: this.$i18n.t('vencida') },
        { value: 'pagada', text: this.$i18n.t('pagada') },
      ],
      filters: {
        SALES_ORDER: "",
        CUSTOMER_PO: "",
        CUSTOMER: "",
        FISCAL_CODE: getCustomerId(), 
        DESCRIPTION: "",
        DESC_LINE: "",
        ITEM: "",
        PRODUCTPROP: "",
        TVOA_STATUS_HEADER:""
      },
      disabled: false,
      wb: null,
    };
  },
};
</script>

